import React from 'react';

const styles = {
    loaderStyle: {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        position: 'relative',
        verticalAlign: 'middle',
        margin: 0,
        left: 0,
        top: 0,
        paddingTop: 6,
        paddingBottom: 6
    }
}

export default function Loader({message, alignCenter}) {
    return (
        <div data-tst='loading' style={{ ...styles.loaderStyle, textAlign: alignCenter ? 'center' : 'left'}}>{message || 'Loading...'}</div>
    );
};